module.exports = __webpack_public_path__ + "static/media/10.f7bfa653.png";